import get from 'lodash.get';

export {
  handleAccessAttemptsPass,
};

function handleAccessAttemptsPass(accessAttempts) {
  if (accessAttempts) {
    const lastIndex = accessAttempts.length - 1;
    return !get(accessAttempts, `[${lastIndex}].attempt_pass`, '') ? ' 📍' : '';
  }
  return '';
}
